import LabSimService from '../services/LabSimService';
export var OutlineType;
(function (OutlineType) {
    OutlineType[OutlineType["Legacy"] = 0] = "Legacy";
    OutlineType[OutlineType["Silverlight"] = 1] = "Silverlight";
    OutlineType[OutlineType["Html5WithoutLocalization"] = 2] = "Html5WithoutLocalization";
    OutlineType[OutlineType["Html5"] = 3] = "Html5";
})(OutlineType || (OutlineType = {}));
export default class OutlineHelper {
    static getCourseRootUrl(product, version, allowLegacyContent) {
        let container = version.outlineHref.replace(/\.xml$/i, '').replace(/_/g, '-');
        const requestedLanguageCode = product.locale;
        const localized = version.outlineType == null || version.outlineType === OutlineType.Html5;
        if (localized) {
            if (requestedLanguageCode != null && requestedLanguageCode.length > 0) {
                container = container + '-' + requestedLanguageCode;
            }
            return (LabSimService.getContentServerUri() +
                '/' +
                container +
                '/' +
                product.locale +
                '/').toLowerCase();
        }
        else {
            if (allowLegacyContent && version.outlineType === OutlineType.Silverlight) {
                const legacyContainer = version.outlineHref.replace(/\.xml$/i, '');
                return ('http://content.testout.com/' + legacyContainer + '/').toLowerCase();
            }
            return (LabSimService.getContentServerUri() + '/' + container + '/').toLowerCase();
        }
    }
}
OutlineHelper.getProductVersionIcon = (product, productVersion, imageExt) => {
    let imgSrc = OutlineHelper.getCourseRootUrl(product, productVersion);
    if (productVersion.outlineType === OutlineType.Silverlight) {
        imgSrc += 'outlines/';
    }
    imgSrc += productVersion.outlineHref.replace('.xml', imageExt).replace(/\\/g, '/');
    imgSrc = imgSrc.toLowerCase();
    return imgSrc;
};
//# sourceMappingURL=OutlineHelper.js.map